export const TEST_ID = 'advancedSection';

export const VALIDATE_COVERAGE_BUTTON_TEST_ID = 'advancedSectionValidateCoverageButton';

export const TITLE = 'Advanced';

export const LABELS = {
    constrainToBoundary: 'Constrain to Boundary',
    fieldMargin: 'Field Margin (ft)',
    obstacleSafetyDistance: 'Obstacle Safety Distance (ft)',
    validateCoverage: 'Validate Coverage'
};

export const CONSTRAIN_OPTIONS = [
    { label: 'Off', value: 'OFF' },
    { label: 'On', value: 'ON' }
];

export const CONSTRAIN_ON_VALUE = 'ON';

export const CONSTRAIN_ON_INDEX = 1;

export const CONSTRAIN_OFF_INDEX = 0;

export const FIELD_MARGIN = { max: 32, min: 0, step: 0.5 };

export const FIELD_MARGIN_METRIC_MAX = 10;

export const OBSTACLE_SAFETY_DISTANCE = { max: 32, min: 0, step: 0.5 };

export const OBSTACLE_SAFETY_DISTANCE_METRIC_MAX = 10;
